import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_MarkdownEditor = _resolveComponent("MarkdownEditor")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.article_id ? _ctx.$t('screenTitle.articleDetail') : _ctx.$t('screenTitle.articleNew')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.isLoading,
        active: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "form",
            model: _ctx.formModel,
            onFinish: _ctx.onFinish,
            rules: _ctx.formRule,
            scrollToFirstError: true,
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.article_title'),
                name: "title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formModel.title,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formModel.title) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.article_slug'),
                name: "slug"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formModel.slug,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.slug) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.article_title_image'),
                name: "title_image"
              }, _createSlots({
                default: _withCtx(() => [
                  _createVNode(_component_UploadImage, {
                    "on-change": _ctx.onChangeUploadTitleImage,
                    "default-images": _ctx.formModel.title_image.length ? [_ctx.formModel.title_image as string] : [],
                    max: 1
                  }, null, 8, ["on-change", "default-images"])
                ]),
                _: 2
              }, [
                (_ctx.formModel.title_image.length)
                  ? {
                      name: "help",
                      fn: _withCtx(() => [
                        _createVNode(_component_a_typography_paragraph, { copyable: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.formModel.title_image), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["label"]),
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.created_at'),
                name: "created_at",
                help: _ctx.$t('message.articleCreatedAtHelp')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_date_picker, {
                    value: _ctx.formModel.created_at,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formModel.created_at) = $event)),
                    "show-time": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label", "help"]),
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.article_content'),
                name: "content"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MarkdownEditor, {
                    modelValue: _ctx.formModel.content,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formModel.content) = $event)),
                    modelModifiers: { lazy: true }
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    "html-type": "submit",
                    block: "",
                    loading: _ctx.isSaving
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('text.save')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "onFinish", "rules"])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["title"]))
}